import { Box, Button, Stack, Typography } from '@mui/material';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import TodayIcon from '@mui/icons-material/Today';
import { useTranslation } from 'react-i18next';
import { SettingsConfig } from './SettingsAccordionConfig';
import useRole from '@/personas/useRole';

/**
 * F5: "Byt roll"-raden överst i inställningarna (ersätter dagens
 * Supervise mode-switch). Visar nuvarande roll och öppnar rollväljaren igen
 * (clearRole) — rollvalet är källan, header-genvägen växlar brukare, inte roll.
 *
 * Dev-only (produktägarbeslut): denna sekundära "byt roll i efterhand"-genväg
 * ska ALDRIG nå produktion. RoleSelectScreen (den initiala rollväljaren vid
 * första login, visad av RoleGate) berörs INTE — det är den avsedda
 * produktionsvägen för rollval. Samma NODE_ENV-check som redan används i
 * serviceWorkerRegistration.ts. Tom fragment (samma mönster som
 * ChangeCharacterSetting) håller toggleComponent-typen (JSX.Element, inte
 * null) och lämnar inget synligt tomrum i vare sig SettingsAccordionConfig-
 * raden eller den inbäddade användningen i ProfileSettings.
 */
const RoleSwitchSetting = (_props: SettingsConfig) => {
  const { t } = useTranslation();
  const { role, clearRole } = useRole();

  if (process.env.NODE_ENV === 'production') return <></>;

  const isSupervisor = role === 'supervisor';
  const roleLabel = isSupervisor ? t('Support someone') : t('My own day');

  return (
    <Box sx={{ p: 2, width: '100%' }}>
      <Stack direction="row" alignItems="center" spacing={2} width="100%">
        <Box aria-hidden sx={{ color: isSupervisor ? 'warning.dark' : 'primary.main' }}>
          {isSupervisor ? <VolunteerActivismIcon /> : <TodayIcon />}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body1" fontWeight={600}>
            {t('Your role right now')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {roleLabel}
          </Typography>
        </Box>
        <Button variant="outlined" color="primary" onClick={clearRole} sx={{ flexShrink: 0 }}>
          {t('Switch role')}
        </Button>
      </Stack>
    </Box>
  );
};

export default RoleSwitchSetting;
